var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"h-100"},[_c('b-colxx',{staticClass:"mx-auto my-auto",attrs:{"xxs":"12","md":"10"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }